import { Controller } from "stimulus"

export default class extends Controller {
  static values = { token: String, room: String, name: String, color: String}
  static targets = ['output']
  initialize() {
    this.createJitsiRoom()
  }

  createJitsiRoom(){
    let token = this.tokenValue
    let _this = this
    const options = {
    roomName: this.roomValue,
    parentNode: this.outputTarget,
    jwt: token ,
    interfaceConfigOverwrite: {
      DEFAULT_BACKGROUND: _this.colorValue ,
      DEFAULT_LOCAL_DISPLAY_NAME: this.nameValue,
      HIDE_INVITE_MORE_HEADER: true,
      INITIAL_TOOLBAR_TIMEOUT: 3000,
      TOOLBAR_TIMEOUT: 2000,
      VIDEO_QUALITY_LABEL_DISABLED: true,
      DISPLAY_WELCOME_FOOTER: false,
      DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD: false,
      DISPLAY_WELCOME_PAGE_CONTENT: false,
      SHOW_CHROME_EXTENSION_BANNER: false,
      DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT: false,
      ENABLE_DIAL_OUT: false,
      TOOLBAR_BUTTONS: [
        'microphone', 'camera', 'desktop', 'fullscreen',
        'fodeviceselection', 'hangup', 'profile', 'chat', 'settings', 'raisehand',
        'videoquality', 'filmstrip', 'shortcuts',
        'tileview', 'videobackgroundblur', 'help', 'mute-everyone'
        ],

      },
    configOverwrite: { startWithAudioMuted: false, prejoinPageEnabled: false, hideConferenceSubject: true },
    };
    let api = new JitsiMeetExternalAPI('meet.meetando.io/', options)
    api.executeCommand('displayName', this.nameValue);
  }
}
